module.exports = __webpack_public_path__ + "img/source04_01.487ae831.png";